import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLAdacWizard from './FNOLAdacWizard';
import FNOLAdacWizardMessages from './FNOLAdacWizard.messages';
import FNOLContext from './components/Context/Context';
import AdacLandingPage from './pages/LandingPage/LandingPage';
import AdacIncidentTypePage from './pages/IncidentType/AdacIncidentTypePage';
import AdacContactDetailsPage from './pages/ContactDetails/AdacContactDetailsPage';
import AdacCallbackOptionsPage from './pages/CallbackOptions/AdacCallbackOptionsPage';
import AdacConfirmationPage from './pages/ConfirmationPage/AdacConfirmationPage';
import AdacLoginPage from './pages/LoginPage/AdacLoginPage';
import AdacCallCenterPage from './pages/CallCenterPage/AdacCallCenterPage';
import AdacTryAgainPage from './pages/TryAgainLaterPage/AdacTryAgainPage';
import AdacSessionExpired from './pages/AdacSessionExpired/AdacSessionExpired';
import AdacMyDocumentsPage from './pages/MyDocumentsPage/AdacMyDocumentsPage';
import AdacServiceConfirmationPage from './pages/ServiceConfirmationPage/AdacServiceConfirmationPage';
import AdacCallbackOptionsPageStandalone from './pages/CallbackOptions/AdacCallbackOptionsPageStandalone';
import AdacSendNotePage from './pages/SendNotePage/SendNotePage';
import AdacConfirmationModal from './components/AdacConfirmationModal';
import AdacErrorModal from './components/AdacErrorModal';
import AdacHeader from './components/AdacHeader/AdacHeader';
import AdacFooter from './components/AdacFooter/AdacFooter';
import AdacDocumentsUpload, { onDocumentsUpload } from './components/DocumentsUpload/AdacDocumentsUpload';
import AdacButtonWithLoader from './components/ButtonWithLoader/ButtonWithLoader';
import AdacDigitalWizardPageTemplate from './templates/AdacDigitalWizardPageTemplate';
import AdacDocumentSigningPage from './pages/AdacDocumentSigningPage/AdacDocumentSigningPage';
import AdacHistoryPage from './pages/AdacHistoryPage/AdacHistoryPage';
import CommunicationHistory from './components/CommunicationHistory/CommunicationHistory';
import { displayLanguageFormattedDate } from './utils/DateFormatterUtil';
import CommunicationVariablesContext from './utils/CommunicationVariablesContext';
import AdacLinkExpiredPage from './pages/AdacLinkExpired/AdacLinkExpiredPage';

setComponentMapOverrides(
    {
        FNOLAdacWizard: { component: 'FNOLAdacWizard' },
        AdacLandingPage: { component: 'AdacLandingPage' },
        AdacIncidentTypePage: { component: 'AdacIncidentTypePage' },
        AdacContactDetailsPage: { component: 'AdacContactDetailsPage' },
        AdacCallbackOptionsPage: { component: 'AdacCallbackOptionsPage' },
        AdacConfirmationPage: { component: 'AdacConfirmationPage' },
        AdacCallCenterPage: { component: 'AdacCallCenterPage' },
        AdacTryAgainPage: { component: 'AdacTryAgainPage' },
        AdacSessionExpired: { component: 'AdacSessionExpired' },
        AdacLoginPage: { component: 'AdacLoginPage' },
        AdacMyDocumentsPage: { component: 'AdacMyDocumentsPage' },
        AdacServiceConfirmationPage: { component: 'AdacServiceConfirmationPage' },
        AdacSendNotePage: { component: 'AdacSendNotePage' },
        AdacCallbackOptionsPageStandalone: { component: 'AdacCallbackOptionsPageStandalone' },
        AdacConfirmationModal: { component: 'AdacConfirmationModal' },
        AdacHeader: { component: 'AdacHeader' },
        AdacFooter: { component: 'AdacFooter' },
        AdacDocumentsUpload: { component: 'AdacDocumentsUpload' },
        AdacErrorModal: { component: 'AdacErrorModal' },
        AdacButtonWithLoader: { component: 'AdacButtonWithLoader' },
        AdacDigitalWizardPageTemplate: { component: 'AdacDigitalWizardPageTemplate' },
        AdacDocumentSigningPage: { component: 'AdacDocumentSigningPage' },
        AdacLinkExpiredPage: { component: 'AdacLinkExpiredPage' }
    },
    {
        FNOLAdacWizard,
        AdacLandingPage,
        AdacIncidentTypePage,
        AdacContactDetailsPage,
        AdacCallbackOptionsPage,
        AdacConfirmationPage,
        AdacCallCenterPage,
        AdacTryAgainPage,
        AdacSessionExpired,
        AdacLoginPage,
        AdacMyDocumentsPage,
        AdacServiceConfirmationPage,
        AdacCallbackOptionsPageStandalone,
        AdacSendNotePage,
        AdacConfirmationModal,
        AdacHeader,
        AdacFooter,
        AdacDocumentsUpload,
        AdacErrorModal,
        AdacButtonWithLoader,
        AdacDigitalWizardPageTemplate,
        AdacDocumentSigningPage,
        AdacLinkExpiredPage
    }
);

export {
    FNOLAdacWizard as default,
    AdacLandingPage,
    AdacIncidentTypePage,
    AdacContactDetailsPage,
    AdacCallbackOptionsPage,
    AdacConfirmationPage,
    AdacLoginPage,
    AdacCallCenterPage,
    AdacTryAgainPage,
    AdacSessionExpired,
    AdacMyDocumentsPage,
    AdacServiceConfirmationPage,
    AdacSendNotePage,
    AdacCallbackOptionsPageStandalone,
    AdacConfirmationModal,
    AdacErrorModal,
    AdacHeader,
    AdacFooter,
    AdacDocumentsUpload,
    onDocumentsUpload,
    FNOLContext,
    FNOLAdacWizardMessages,
    AdacButtonWithLoader,
    AdacDigitalWizardPageTemplate,
    AdacDocumentSigningPage,
    AdacHistoryPage,
    displayLanguageFormattedDate,
    CommunicationHistory,
    CommunicationVariablesContext,
    AdacLinkExpiredPage
};
